<template>
    <div class="line-selection-page">
        <v-container>
            <app-header sub-heading="Velg rute" :date="date" />
            <div v-if="linesStore.lines.length > 0">
                <v-row>
                    <v-col>
                        <v-tabs v-if="showMpcAvvik" v-model="viewSelection" class="selection-tabs" centered height="30">
                            <v-tab key="mpc" data-id="mpc" @click="setView(Views[ViewIndex.mpc])"> MPC </v-tab>
                            <v-tab key="avvik" data-id="avvik" @click="setView(Views[ViewIndex.avvik])"> Avvik </v-tab>
                        </v-tabs>
                        <br />
                    </v-col>
                </v-row>
                <v-row data-id="lines">
                    <v-col v-for="line in linesStore.lines" :key="line.number" cols="3" class="d-flex align-center justify-center">
                        <v-btn
                            fab
                            height="64"
                            width="64"
                            color="#F5F5F5"
                            icon
                            elevation="5"
                            :to="{
                                name: 'departures',
                                params: {
                                    lineNumber: line.number
                                },
                                query: { token: router.currentRoute.value.query.token, view: getViewName(viewSelection) }
                            }"
                            :disabled="!baseStore.isOnline && line.number !== baseStore.lineNumber"
                        >
                            <span class="title">{{ line.name }}</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
            <v-overlay v-else-if="baseStore.isLoading">
                <v-progress-circular indeterminate size="64" />
            </v-overlay>
            <div v-else>
                <p class="text-center">
                    <v-icon size="36"> mdi-alert-outline </v-icon>
                </p>
                <h3 class="headline text-center">Ingen ruter funnet</h3>
                <p class="body-2 text-center">
                    Ingen ruter ble funnet for denne operatøren.<br />
                    Vennligst sjekk at du har korrekt adgangsnivå, og kontakt oss dersom feilen vedvarer.
                </p>
            </div>
        </v-container>
    </div>
</template>

<script setup lang="ts">
import AppHeader from '@/features/shared/AppHeader.vue';
import { useEmitter, Events } from '@/plugins/emitter';
import { ref, computed, withDefaults } from 'vue';
import { useRouter } from 'vue-router';
import { Views, ViewIndex, getViewName } from '@/helpers/ViewSwitcher';
import { useBaseStore } from '@/features/shared/baseStore';
import { useLinesStore } from '@/features/lines/linesStore';
import { useSettingsStore } from '@/features/shared/settingsStore';

interface Props {
    date?: string;
}
withDefaults(defineProps<Props>(), {
    date: ''
});
const eventbus = useEmitter();

const viewSelection = ref(null);
const baseStore = useBaseStore();
const settingsStore = useSettingsStore();
const linesStore = useLinesStore();
const router = useRouter();

const showMpcAvvik = computed(() => {
    return settingsStore.settings && settingsStore.showMpcAvvik;
});

const showMpc = computed(() => {
    return settingsStore.settings && settingsStore.showMpc;
});

const showAvvik = computed(() => {
    return settingsStore.settings && settingsStore.showAvvik;
});

function initialize() {
    const selectedView = router.currentRoute.value.query.view;

    if (selectedView === Views[ViewIndex.avvik] && showAvvik.value) {
        viewSelection.value = ViewIndex.avvik;
        setView(Views[ViewIndex.avvik]);
    } else if (selectedView === Views[ViewIndex.mpc] && showMpc.value) {
        viewSelection.value = ViewIndex.mpc;
        setView(Views[ViewIndex.mpc]);
    } else {
        setView(showMpc.value ? Views[ViewIndex.mpc] : Views[ViewIndex.avvik]);
    }
    baseStore.clearMenuItems();
    eventbus.emitter.emit(Events.menuUpdate, 'lines');
}

function setView(view: string) {
    if (router.currentRoute.value.query.view !== view) {
        router.replace({ name: 'home', query: { token: router.currentRoute.value.query.token, view } });
    }
}

initialize();
</script>
@/services/emitter
